import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { trackWidgetVersion } from '@migros/msrc-analytics';
import { i18n } from '@migros/msrc-i18n';
import { MsrcThemeProvider } from '@migros/msrc-ui-kit';
import React, { useEffect, useRef } from 'react';
import { ArticleSlider } from '../../compositions/articleslider/ArticleSlider';
import { DEFAULT_ARTICLE_SLIDER_SKELETON_COUNT, ResponseStatus, TileLayout, defaultOptions } from '../../helpers';
import { extractTrackingInfoFromArticle, trackArticleTileImpression, trackSliderMovement } from '../../helpers/tracking';
import { useI18n } from '../../hooks/use-i18n';
import { useSliderData } from '../../hooks/useSliderData';
import { fetchProducts } from '../../services/web-api';
export const ProductSliderWidget = ({
  environment,
  webAPIKey,
  theme = defaultOptions.theme,
  language = defaultOptions.language,
  limit = defaultOptions.sliderLimit,
  offset = defaultOptions.sliderOffset,
  mode = defaultOptions.mode,
  hideDescription = defaultOptions.hideDescription,
  hideRating = defaultOptions.hideRating,
  hideEnergyEfficiency = defaultOptions.hideEnergyEfficiency,
  hideBadge = defaultOptions.hideBadge,
  linkToFm = defaultOptions.linkToFm,
  order,
  sort,
  layout = TileLayout.default,
  headingTagsLevel = defaultOptions.headingTagsLevel,
  filterOptions = defaultOptions.productFilterOptions,
  trackingInfo,
  tilesVisibleCount = defaultOptions.tilesVisibleCount[layout],
  customTarget = {}
}) => {
  useEffect(() => {
    trackWidgetVersion("1.84.0", 'msrc-articles:productslider-widget');
  }, []);
  const mergedFilterOptions = _objectSpread(_objectSpread({}, defaultOptions.productFilterOptions), filterOptions);
  useI18n(language);
  const {
    entities: articles,
    loading,
    responseStatus
  } = useSliderData({
    environment,
    webAPIKey,
    limit,
    offset,
    language,
    order,
    sort,
    filterOptions: mergedFilterOptions,
    fetchFunction: fetchProducts
  });
  const widgetRef = useRef(null);
  const onSwipe = swipeDirection => trackSliderMovement(widgetRef, swipeDirection);
  const onPrevArrowClick = () => trackSliderMovement(widgetRef, 'right');
  const onNextArrowClick = () => trackSliderMovement(widgetRef, 'left');
  return /*#__PURE__*/React.createElement(MsrcThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement("div", {
    ref: widgetRef,
    "data-testid": "msrc-articles--product-slider-widget"
  }, responseStatus === ResponseStatus.ok ? /*#__PURE__*/React.createElement(ArticleSlider, {
    articles: articles,
    mode: mode,
    loading: loading,
    hideDescription: hideDescription,
    hideRating: hideRating,
    hideEnergyEfficiency: hideEnergyEfficiency,
    hideBadge: hideBadge,
    linkToFm: linkToFm,
    heading: headingTagsLevel,
    language: language,
    trackingInfo: trackingInfo,
    skeletonCount: DEFAULT_ARTICLE_SLIDER_SKELETON_COUNT,
    layout: layout,
    onSwipe: onSwipe,
    onPrevArrowClick: onPrevArrowClick,
    onNextArrowClick: onNextArrowClick,
    onArticleClick: (article, index) => {
      const {
        position,
        trackOnClick,
        trackingInformation,
        ratings
      } = extractTrackingInfoFromArticle(article, index);
      trackOnClick(position, trackingInformation, article.id, ratings, trackingInfo);
    },
    onArticleImpression: (article, index) => {
      const {
        position,
        defaultTrackingInformation,
        ratings
      } = extractTrackingInfoFromArticle(article, index);
      trackArticleTileImpression(position, defaultTrackingInformation, article.id, trackingInfo, ratings);
    },
    tilesVisibleCount: tilesVisibleCount,
    customTarget: customTarget
  }) : i18n.t('components.articleslider.error')));
};